module.exports = __webpack_public_path__ + "static/media/29ADMSPC11.086742ee.jpg";